import {
  Button,
  Checkbox,
  Chip,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  LinearProgress,
  MenuItem,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { DropzoneArea } from 'mui-file-dropzone';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { GridComponent } from 'src/components/common/GridComponent';
import Loader from 'src/components/common/Loader';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { sendRequest } from 'src/hooks/useFetch';
import { hideLoader, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { useAppSelector } from 'src/store/hooks';
import { IDocumentArtifactInfo, IUploadedDocumentISF } from 'src/types/UploadedDocumentISF';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { formatInput } from 'src/util/STR';
import './DocumentUpload.scss';
import { useDocumentUploads } from './useDocumentUploads';

interface IDARUploadDocProps {
  documentMetaData: any;
  uploadDilogOpen: boolean;
  setUploadDilogOpen: any;
  uploadedFiles: any;
  updateDocs: any;
  progress: boolean;
  permission: boolean;
}
const DARDocUpload: React.FunctionComponent<any> = (props: IDARUploadDocProps) => {
  const [isUpload, setIsUpload] = useState<boolean>(false);
  const [cnfDilog, setCnfDilog] = useState<boolean>(false);
  const [dfile, setDfile] = useState<any>([]);
  const [styleUpload, setStyleUpload] = useState('uploadFile');
  const error = null;
  const useStyles = makeStyles(() =>
    createStyles({
      previewChip: {
        minWidth: 100,
        maxWidth: 210
      }
    })
  );
  const {
    getISFDocInfoByLevelTypeArtifactNameDataQuery,
    getAllISFDocInfoByArtifactNumberSiteLevelData,
    createMasterDocumentIsf,
    deleteMasterDocumentIsf
  } = useDocumentUploads();
  const [docVersion, setDocVersion] = useState('');
  const [docCreatedOn, setDocCreatedOn] = useState('');
  const [docName, setDocName] = useState<string>('');
  const [deleteDocFileMasterId, setDeleteFileMasterDocId] = useState('');
  const [openDeleteDocPopup, setOpenDeleteDocPopup] = useState(false);
  const [selectedDocsList, setSelectedDocsList] = useState<any>([]);
  const [fileChipList, setFileChipList] = useState<any[]>([]);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);

  const [includesPHICheck, setIncludesPHICheck] = useState<boolean>(false);
  const initialFileUploadData: IUploadedDocumentISF = {
    isf_prefix: '',
    isf_raw_file_name: '',
    isf_bucket_name: '',
    isf_hashed_file_name: '',
    isf_doc_version_number: 0,
    isf_doc_size: '',
    isf_doc_type: '',
    isf_doc_viewer_pages: '',
    id: '',
    is_active: false,
    isf_doc_created_by: '',
    isf_doc_upload_date: '',
    created_on: '',
    updated_on: ''
  };
  const [fileUploadData, setFileUploadData] = useState<IUploadedDocumentISF>(initialFileUploadData);
  const [artifactInfo, setArtifactInfo] = useState<IDocumentArtifactInfo>({
    isf_artifact_number: '',
    isf_artifact_name: '',
    isf_doc_type: '',
    isf_doc_subtype: '',
    isf_doc_milestone: ''
  });

  const { duFileUploadErrorMsg } = useFieldTranslation();
  const { preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const handleCancel = () => {
    if (dfile.length === 0) {
      props.setUploadDilogOpen(false);
    } else {
      setCnfDilog(true);
    }
   
  };
  const clearData = () => {
    setIsUpload(false);
    setIncludesPHICheck(false);
    setSelectedDocsList([]);
    setDfile([]);
    setDocName('');
    setFileUploadData(initialFileUploadData);
    setCnfDilog(false);
    props.setUploadDilogOpen(false);
  };
  const classes = useStyles();
  const dispatch = useDispatch();
  useEffect(() => {
    if (isUpload) {
      if (error) {
        setStyleUpload('uploadFileError');
      } else {
        setStyleUpload('uploadFileSuccess');
      }
    } else {
      setStyleUpload('uploadFile');
    }
  }, [isUpload, error]);
  const handleRejectedMessage = (rejectedFile: any, acceptedFiles: any, maxFileSize: any) => {
    let message = `${rejectedFile.name} cannot be uploaded! , `;
    const arrFile = rejectedFile.name.split('.');
    if (!acceptedFiles.includes(`.${arrFile[arrFile.length - 1]}`)) {
      message += `File Format is not supported`;
    } else if (rejectedFile.size > maxFileSize) {
      message += `File Size more than 5MB is not allowed.`;
    }
    return message;
  };

  const handleDocumentName = (e: any) => {
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    setDocName(formattedVal);
  };

  useEffect(() => {
    if (fileUploadData) {
      if (fileUploadData.isf_doc_version_number > 0) {
        setDocVersion(fileUploadData.isf_doc_version_number.toFixed(1));
        setDocCreatedOn(preferedDateFormat(fileUploadData.created_on.slice(0, 10)));
      }
    }
  }, [fileUploadData]);

  const handleCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIncludesPHICheck(event.target.checked);
  };
  const handleDocDeletePopupClose = () => {
    setOpenDeleteDocPopup(false);
  };
  const handleDocDeleteDialog = (docFileMasterId: string) => {
    setDeleteFileMasterDocId(docFileMasterId);
    setOpenDeleteDocPopup(true);
  };
  const getISFDocInfo = async (artifactName: string | undefined) => {
    try {
      dispatch(showLoader());
      const docResult: any = await getISFDocInfoByLevelTypeArtifactNameDataQuery({
        level_type: 'Site',
        artifactName,
        study_id: studyId,
        country: selectedCountry,
        site_id: selectedSite,
        application: process.env.REACT_APP_NAME,
        module_section_related: 'STUDY LOGS',
        parent_entity_related: ''
      });

      setArtifactInfo({
        ...docResult?.data,
        isf_artifact_name: props.documentMetaData?.name
      });
      dispatch(hideLoader());
    } catch (error: any) {
      dispatch(hideLoader());
    }
  };
  const getFileChipList = async () => {
    const chipsArray: any[] = [];
    if (props.uploadedFiles.length > 0) {
      dispatch(showLoader());
      let darDocsList: any[] = [];
      try {
        const result: any = await getAllISFDocInfoByArtifactNumberSiteLevelData({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          artifactName: props.documentMetaData?.name,
          artifactNumber: props.documentMetaData?.number,
          originally_uploaded: true,
          application: process.env.REACT_APP_NAME,
          module_section_related: 'STUDY LOGS',
          parent_entity_related: ''
        });
        if (result.isSuccess && result?.data?.selected_data.length > 0) {
          darDocsList = result?.data?.selected_data.filter((docToLink: any) =>
            props.uploadedFiles.includes(docToLink.document_data.id)
          );
        }
        dispatch(hideLoader());
      } catch (error: any) {
        dispatch(hideLoader());
      }
      setSelectedDocsList(darDocsList);
      if (darDocsList.length > 0) {
        darDocsList.map((trngDoc: any, index: number) => {
          props.permission
            ? chipsArray.push(
                <Chip
                  sx={{ ml: 1 }}
                  key={index}
                  label={trngDoc.document_data.isf_document_name}
                  variant="outlined"
                  className="upload-doc-chip"
                  onDelete={() => handleDocDeleteDialog(trngDoc.file_master.id)}
                />
              )
            : chipsArray.push(
                <Chip
                  sx={{ ml: 1 }}
                  key={index}
                  label={trngDoc.document_data.isf_document_name}
                  variant="outlined"
                  className="upload-doc-chip"
                />
              );
        });
      }
      setFileChipList(chipsArray);
      dispatch(hideLoader());
    } else {
      setFileChipList(chipsArray);
    }
  };
  useEffect(() => {
    if (props.uploadDilogOpen) {
      getISFDocInfo(props.documentMetaData?.name);
      getFileChipList();
    }
  }, [props.uploadDilogOpen]);

  const uploadFile = async (file: any): Promise<IUploadedDocumentISF> => {
    try {
      dispatch(showLoader());
      const formData = new FormData();
      formData.append('file', file);
      const options = {
        endPointEnv: 'isf',
        data: formData,
        pathVariables: {
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          appName: process.env.REACT_APP_NAME,
          module_section_related: 'STUDY LOGS',
          parent_entity_related: ''
        }
      };
      // const response: any = await uploadIsfMasterFile({
      //   data: formData,
      //   study_id: studyId,
      //   country: selectedCountry,
      //   site_id: selectedSite,
      //   application: process.env.REACT_APP_NAME
      // });
      const response: any = await sendRequest('isf_file_master_upload_file', options);
      dispatch(hideLoader());
      return response;
    } catch {
      dispatch(hideLoader());
      dispatch(setMessage({ msgDetails: duFileUploadErrorMsg, severity: 'error' }));
      return Promise.reject();
    }
  };
  const uploadDataFile = async (): Promise<any> => {
    if (dfile) {
      const result = await uploadFile(dfile[0]);
      if (result) {
        setFileUploadData(result);
        return result;
      } else {
        return false;
      }
    }
  };
  const handleUploadDocument = async () => {
    const check = await uploadDataFile();
    if (!check) {
      return;
    }
    if (docName !== '') {
      const isDocNameExists = selectedDocsList.some(
        (existedDoc: any) => existedDoc.document_data.isf_document_name === docName
      );
      if (!isDocNameExists) {
        try {
          dispatch(showLoader());
          const isfUploadDocObj = {
            file_master_id: check.id,
            document_data: {
              isf_artifact_number: artifactInfo.isf_artifact_number,
              isf_document_name: docName,
              isf_doc_type: artifactInfo.isf_doc_type,
              isf_doc_subtype: artifactInfo.isf_doc_subtype,
              isf_doc_viewer_includes_phi: includesPHICheck,
              isf_doc_viewer_red_certified_copy: 'N',
              isf_doc_status: 'Uploaded',
              isf_doc_country: selectedCountry,
              isf_doc_study: studyId,
              isf_doc_site: selectedSite,
              isf_doc_viewer_department: 'None',
              isf_doc_viewer_language: 'English',
              isf_doc_viewer_approval_cycle: 0,
              isf_doc_viewer_product_detail: 'test1',
              isf_doc_viewer_ref_model_version: 'ISF RM v1.0',
              isf_doc_viewer_format: 'PDF',
              isf_doc_viewer_inspection_ready: '',
              isf_doc_viewer_ir_issue_type: '',
              isf_doc_level: 'Site',
              isf_artifact_name: artifactInfo.isf_artifact_name,
              isf_doc_version_number: check.isf_doc_version_number,
              isf_doc_milestone: artifactInfo.isf_doc_milestone,
              isf_document_id: 'str',
              isf_doc_viewer_doc_phi_redacted: 'N',
              isf_doc_viewer_created_by: check.isf_doc_created_by,
              application: process.env.REACT_APP_NAME,
              module_section_related: 'STUDY LOGS',
              parent_entity_related: ''
            }
          };
          const response: any = await createMasterDocumentIsf({
            data: isfUploadDocObj,
            study_id: studyId,
            country: selectedCountry,
            site_id: selectedSite,
            application: process.env.REACT_APP_NAME,
            module_section_related: 'STUDY LOGS',
            parent_entity_related: ''
          });
          const updatedDocIds: string[] = [];
          selectedDocsList.map((doc: any) => {
            updatedDocIds.push(doc.document_data.id);
          });
          updatedDocIds.push(response?.data?.document_data.id);
          clearData();
          dispatch(hideLoader());
          props.updateDocs(updatedDocIds);
          props.setUploadDilogOpen(false);
        } catch (error: any) {
          dispatch(hideLoader());
          dispatch(setMessage({ msgDetails: duFileUploadErrorMsg, severity: 'error' }));
        }
      } else {
        dispatch(setMessage({ msgDetails: 'Duplicate document identified.', severity: 'error' }));
      }
    } else {
      dispatch(setMessage({ msgDetails: 'Document name is missing', severity: 'error' }));
    }
  };
  const handleDocDeleteconfirm = async () => {
    try {
      dispatch(showLoader());
      await deleteMasterDocumentIsf({
        file_master_id: deleteDocFileMasterId,
        study_id: studyId,
        country: selectedCountry,
        site_id: selectedSite,
        application: process.env.REACT_APP_NAME,
        module_section_related: 'STUDY LOGS',
        parent_entity_related: ''
      });

      const updatedDocIds: string[] = [];
      selectedDocsList.map((doc: any) => {
        if (doc.file_master.id !== deleteDocFileMasterId) {
          updatedDocIds.push(doc.document_data.id);
        }
      });
      props.updateDocs(updatedDocIds, true);
      props.setUploadDilogOpen(false);
      setOpenDeleteDocPopup(false);
      dispatch(hideLoader());
    } catch (error: any) {
      dispatch(hideLoader());
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      } else {
        dispatch(setMessage({ msgDetails: 'Error in Document Delete', severity: 'error' }));
      }
    }
    setSelectedDocsList([]);
  };
  useEffect(() => {
    if (dfile.length) {
      setIsUpload(true);
    } else {
      setIsUpload(false);
    }
  }, [dfile]);

  return (
    <div>
      <PopupComponent
        open={props.uploadDilogOpen}
        // onClose={() => props.setUploadDilogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        className="uploadModal"
      >
        <DialogContent sx={{ p: 2, pb: 0, maxWidth: '840px !important', '& .MuiChip-labelMedium:has(+ .MuiSvgIcon-root)': { maxWidth: '740px', overflow: 'hidden !important' } }}>
          <div id="uploadFile" className={props.permission ? styleUpload : `${styleUpload} noUploadCaseDARModel`}>
            <Loader />
            <DropzoneArea
              fileObjects={[]}
              showPreviewsInDropzone={isUpload}
              filesLimit={1}
              showAlerts={['error', 'info']}
              maxFileSize={5000000}
              acceptedFiles={['.pdf', '.doc', '.docx']}
              useChipsForPreview
              showFileNames={false}
              dropzoneText={`Drag and drop your file here or`}
              previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
              previewChipProps={{ classes: { root: classes.previewChip } }}
              previewText="Selected files"
              onChange={(e: any) => {
                if (e.length > 0) {
                  setDfile(e);
                  setIsUpload(true);
                  dispatch(setMessage({ msgDetails: `Your file ${e?.[0]?.name} has been successfully uploaded.`, severity: 'success' }));
                }
              }}
              getFileLimitExceedMessage={(_: number) =>
                'You cannot upload more than one file at once. Please try with single file'
              }
              getDropRejectMessage={handleRejectedMessage}
            />
            <Typography
              variant="body2"
              display="block"
              color="text.secondary"
              gutterBottom
              sx={{ mt: -4, textAlign: 'center', position: 'relative', zIndex: 12 }}
            >
              <strong>Accepted file type:&nbsp;</strong>{['.pdf', '.doc', '.docx'].toString()}
            </Typography>
          </div>

          {props.progress ? <LinearProgress /> : <></>}
          <Grid item md={12}>
            <Grid container spacing={2}>
              <Grid item md={4}>
                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled={!isUpload}
                    required
                    id="standard-select-currency-native"
                    label="Document Name "
                    variant="standard"
                    value={docName}
                    inputProps={{
                      maxLength: 200
                    }}
                    onChange={e => handleDocumentName(e)}
                  />
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    select
                    label="Version Number"
                    variant="standard"
                    value={docVersion}
                  >
                    <MenuItem value={docVersion}>{docVersion}</MenuItem>
                  </TextField>
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    select
                    required
                    label="Artifact Number"
                    variant="standard"
                    value={artifactInfo.isf_artifact_number}
                  >
                    <MenuItem value={artifactInfo.isf_artifact_number}>{artifactInfo.isf_artifact_number}</MenuItem>
                  </TextField>
                </FormControl>
              </Grid>
              <Grid item md={4}>
                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    select
                    required
                    label="Artifact Name"
                    variant="standard"
                    value={artifactInfo.isf_artifact_name}
                  >
                    <MenuItem value={artifactInfo.isf_artifact_name}>{artifactInfo.isf_artifact_name}</MenuItem>
                  </TextField>
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    select
                    label="Type"
                    variant="standard"
                    value={artifactInfo.isf_doc_type}
                  >
                    <MenuItem value={artifactInfo.isf_doc_type}>{artifactInfo.isf_doc_type}</MenuItem>
                  </TextField>
                </FormControl>
                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    label="Upload Date"
                    placeholder={userPreferedDateFormat.toLowerCase()}
                    variant="standard"
                    type={isUpload ? 'text' : ''}
                    value={isUpload ? docCreatedOn : ''}
                  />
                </FormControl>
              </Grid>
              <Grid item md={4}>
                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-required"
                    select
                    label="Milestone"
                    value={artifactInfo.isf_doc_milestone}
                    variant="standard"
                    InputProps={{
                      readOnly: true
                    }}
                  >
                    <MenuItem value={artifactInfo.isf_doc_milestone}>{artifactInfo.isf_doc_milestone}</MenuItem>
                  </TextField>
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    select
                    label="Subtype"
                    variant="standard"
                    value={artifactInfo.isf_doc_subtype}
                  >
                    <MenuItem value={artifactInfo.isf_doc_subtype}>{artifactInfo.isf_doc_subtype}</MenuItem>
                  </TextField>
                </FormControl>
                <FormControlLabel
                  control={<Checkbox disabled={!isUpload} checked={includesPHICheck} onChange={handleCheckBox} />}
                  label="Includes PHI?"
                />
              </Grid>
            </Grid>
          </Grid>
          {fileChipList.length > 0 && (
            <GridComponent sx={{ mt: 1 }}>
              <Stack direction="row" spacing={1} className="upload-doc-chip">
                <div>{fileChipList}</div>
              </Stack>
            </GridComponent>
          )}
          <DialogActions>
            <Stack direction="row" spacing={2}>
              <Button variant="text" href="#contained-buttons" className="grey-btn" onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                variant="text"
                href="#contained-buttons"
                onClick={() => (props.permission ? handleUploadDocument() : props.setUploadDilogOpen(false))}
                disabled={props.progress}
              >
                Submit
              </Button>
            </Stack>
          </DialogActions>
        </DialogContent>
      </PopupComponent>

      <PopupComponent
        open={openDeleteDocPopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Loader />
        <DialogTitle id="alert-dialog-title">{'Delete the document?'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">Do you want to delete the document?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDocDeleteconfirm} autoFocus>
            Yes
          </Button>
          <Button onClick={handleDocDeletePopupClose}>No</Button>
        </DialogActions>
      </PopupComponent>
      <PopupComponent open={cnfDilog}>
        <DialogTitle id="alert-dialog-title">{'Cancel Document Upload'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to cancel uploading this document?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={clearData} autoFocus className='grey-btn'>
            Yes
          </Button>
          <Button onClick={() => setCnfDilog(false)}>No</Button>
        </DialogActions>
      </PopupComponent>
    </div>
  );
};

export default DARDocUpload;
